import { BubbleMenu as e } from "../../components/bubble-menu/BubbleMenu.mjs";
import { LinkBubbleEdit as t, LinkBubbleView as n } from "./link-bubble-state.mjs";
import { FileSelectorModal as r } from "@systemeio/file-manager";
import { useEditorState as i } from "@tiptap/react";
import { useEffect as a, useState as o } from "react";
import { twJoin as s } from "tailwind-merge";
import { Fragment as c, jsx as l, jsxs as u } from "react/jsx-runtime";
import { TextSelection as d } from "@tiptap/pm/state";
//#region src/extensions/link-extension/link-bubble-menu.tsx
var f = ({ editor: f, fileSource: p, options: m }) => {
	let h = i({
		editor: f,
		selector: ({ editor: e }) => ({ href: e?.getAttributes("link").href })
	})?.href, [g, _] = o(!1), [v, y] = o(!1);
	a(() => {
		_(!h);
	}, [h]);
	let b = () => f?.chain().focus().extendMarkRange("link").unsetLink().setMeta("addToHistory", !1).run(), x = (e) => {
		f && (_(!1), f.chain().focus().extendMarkRange("link").setLink({ href: e }).run());
	}, S = () => {
		if (!f) return;
		let e = f.state.schema.marks.link;
		if (!e) return;
		let { tr: t } = f.state, n = !1;
		f.state.doc.descendants((r, i) => {
			r.marks.some((t) => t.type === e && !t.attrs.href) && (t.removeMark(i, i + r.nodeSize, e), n = !0);
		}), n && (t.setMeta("addToHistory", !1), f.view.dispatch(t));
	};
	return !f || !f?.options.editable ? null : /* @__PURE__ */ u(c, { children: [/* @__PURE__ */ l(e, {
		className: s(v && "hidden"),
		editor: f,
		pluginKey: "linkBubbleMenu",
		options: { onHide: () => {
			_(!1), S();
		} },
		shouldShow: ({ editor: e, state: t }) => e.isActive("link") && t.selection instanceof d,
		children: /* @__PURE__ */ l("form", {
			onSubmit: (e) => e.preventDefault(),
			className: "flex items-center p-2",
			children: g ? /* @__PURE__ */ l(t, {
				initialValue: h ?? "",
				onSaveLink: x,
				openFileSelector: () => {
					f.commands.blur(), y(!0);
				},
				schemeOptions: m?.schemeOptions
			}) : /* @__PURE__ */ l(n, {
				href: h ?? "",
				unsetLink: b,
				setIsEditing: _
			})
		})
	}), /* @__PURE__ */ l(r, {
		uploadingFromSource: p,
		initialSearchFilters: {
			source: [p],
			name: "",
			type: []
		},
		opened: v,
		onClose: () => {
			y(!1), S();
		},
		onSelect: (e) => {
			x(e.path), y(!1);
		}
	})] });
};
//#endregion
export { f as LinkBubbleMenu };
